import { Button } from "components/ui/button";
import { DownloadCloudIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { TaskBase } from "pages/project/common/taskBase.typing";
import { useHubConnection } from "store/useHubConnection";
import { toast } from "react-hot-toast";

interface Props {
  selectedTaskBase: TaskBase;
  disableGeneration: boolean;
  onGenerateQAReport: (hubConnectionId: string) => void;
}

export function TaskXtmQASidebar({ selectedTaskBase, disableGeneration, onGenerateQAReport }: Props) {
  const { t } = useTranslation();
  const hub = useHubConnection((state) => state.connection);

  const handleGenerateXtmQAReport = () => {
    if (selectedTaskBase) {
      // Use hub connection ID if available, otherwise use a fallback
      const hubConnectionId = hub?.connectionId || "default";
      onGenerateQAReport(hubConnectionId);
    } else {
      toast.error(t("translation:common.hub.failedToConnect"));
    }
  };

  return (
    <div className="flex justify-center">
      <Button
        variant="outline"
        disabled={disableGeneration}
        data-test="btn-generate-qa-report"
        className="flex w-full flex-nowrap gap-2 text-nowrap"
        onClick={handleGenerateXtmQAReport}
      >
        <DownloadCloudIcon className="size-5 shrink-0" data-icon="DownloadCloudIcon" />
        <span>{t("translation:task-qa.generate-report")}</span>
      </Button>
    </div>
  );
}
